
/**
 * Enum describing the names of the various Address Input fields
 */
export enum AddressFields {
    Name = 'Name',
    Street = 'Street',
    City = 'City',
    State = 'State',
    ZipCode = 'ZipCode',
    Phone = 'Phone',
    Country = 'ThreeLetterISORegionName'
}